/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_4_SolutionInputs */

const et_portfolio_project_4_solution = /** @type {(inputs: Portfolio_Project_4_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimeerisime Google'i kohaloleku, parandasime kohalikku SEO-d ja rakendasime arvustuste kogumise süsteemi.`)
};

const en_portfolio_project_4_solution = /** @type {(inputs: Portfolio_Project_4_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimized Google presence, improved local SEO, and implemented a review acquisition system.`)
};

/**
* | output |
* | --- |
* | "Optimized Google presence, improved local SEO, and implemented a review acquisition system." |
*
* @param {Portfolio_Project_4_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_4_solution = /** @type {((inputs?: Portfolio_Project_4_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_4_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_4_solution(inputs)
	return en_portfolio_project_4_solution(inputs)
});